import { render, staticRenderFns } from "./AuditDetailGoods.vue?vue&type=template&id=4c232e96&scoped=true"
import script from "./AuditDetailGoods.vue?vue&type=script&lang=js"
export * from "./AuditDetailGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c232e96",
  null
  
)

export default component.exports